'format es6';
'use strict';

import $ from 'jquery';
import ns from 'ns';
import gsap from 'greensock';
import Menu from './Menu';

ns.docReady.then(() => {
	let mainMenu = new Menu().init();
	let $window = $(window);
	let scroll = {y:$window.scrollTop()};

	$('.page-intro, .text-block').find('.scrollto').on('click', (e)=>{
		e.preventDefault();

		let clicked = $(e.target);
		let targetTab = $('[data-scrollto-section="' + clicked.data('scrollto') + '"]');
		let targetPos = targetTab.offset().top - $('header').height();

		scroll = {y:$window.scrollTop()};

		gsap.TweenMax.to(scroll, 1.2, {
			y: targetPos,
			ease:gsap.Expo.easeInOut,
			delay:0,
			onUpdate:()=>{
				$window.scrollTop(scroll.y);
			}
		});
	});
});
